import { isNoTouchOrTrialOrAfterTrial } from "app/UtilitiesAndConstants/UtilityFunctions/trialUsersUtils";

export const getExcelButtonText = (): string => isNoTouchOrTrialOrAfterTrial() && "nt.excel.download.button.text";
